import EscaninhoStore from '@/store/EscaninhoStore';
import { CloudDownload, Gavel, OpenInNew, Description, InfoOutlined } from '@mui/icons-material';
import { Chip, CircularProgress, IconButton, Tooltip } from '@mui/material';
import { observable, runInAction, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import moment from 'moment';
import React from 'react';
import fetch from '../../api/AxiosAdapter';
import Configuracao from '../../misc/Configuracao';
import IconeCertidao from '../../img/icones/IconeCertidao';
import IconeDespacho from '../../img/icones/IconeDespacho';
import IconeVoto from '../../img/icones/IconeVoto';
import { EnumOrigemProcesso, TipoMinuta } from '../../modelo';
import { Peca } from '../../modelo/dominio/Peca';
import { DadosProcessoDto } from '../../modelo/dto/DadosProcessoDto';
import InformacoesProcessoService from '../../services/InformacoesProcessoService';
import MensagemStore from '../../store/MensagemStore';
import ProcessoExpandidoStore from '../../store/ProcessoExpandidoStore';
import './css/LinkPecaStyles.css';
import ModalSituacaoPeca from './ModalSituacaoPeca';

const ICONES_MINUTA = new Map([
    [TipoMinuta.DESPACHO, <IconeDespacho />],
    [TipoMinuta.DECISAO, <Gavel />],
    [TipoMinuta.VOTO, <IconeVoto />]
]);

const VARIAVEL_DESPACHO_ADMISSIBILIDADE = 'DespachoAdmissibilidade';
const CHAVE_DESPACHO_ADMISSIBILIDADE = 'DESPACHOADMISSIBILIDADE';

interface IProps {
    peca: Peca
    dadosProcesso?: DadosProcessoDto;
    openPeca: (blob) => void;
    openHTML?: (blob) => void;
    exibirSituacaoPeticao?: boolean;
}

export const LinkPeca = observer(class LinkPeca extends React.Component<IProps> {

    carregandoVisualizacao = false;
    carregandoDownload = false;

    constructor(props: IProps) {
        super(props);

        makeObservable(this, {
            carregandoVisualizacao: observable,
            carregandoDownload: observable
        });
    }

    get isPeticaoPendente() {
        if (this.isOrigemEsij) {
            return this.peca.codigoPeticaoStatus != null && this.peca.codigoPeticaoStatus != 6 && this.peca.codigoPeticaoStatus != 7;
        } else {
            return this.peca.descricaoPeticaoStatus == 'Não apreciada';
        }
    }

    get peca(): Peca {
        return this.props.peca;
    }

    get isDespachoAdmissibilidade() {
        return (this.peca as any).pecaDespachoAdmissibilidade === true;
    }

    get numeroProcessoDespachoAdmissibilidade() {
        return (this.peca as any).numeroProcesso;
    }

    abrirCertidao = async (peca: Peca) => {
        fetch(InformacoesProcessoService.consultarConteudoCertidao(peca.idProcesso, peca.id), {
            method: 'GET',
            responseType: "blob"
        })
            .then((r) => r.data as Blob)
            .then(blob => {
                this.props.openPeca(blob);
                //this.showFile(blob, 'Certidao');
            });
    }

    showFile = (blob, nome) => {

        const newBlob = new Blob([blob], { type: "application/pdf" })

        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveOrOpenBlob(newBlob);
            return;
        }

        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        link.download = nome + ".pdf";
        link.click();
        setTimeout(function () {
            window.URL.revokeObjectURL(data);
        }, 100);
    }

    baixarArquivo = (blob: Blob, nomeArquivo: string) => {
        const data = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = data;
        link.download = nomeArquivo;
        link.click();
        setTimeout(function () {
            window.URL.revokeObjectURL(data);
        }, 100);
    }

    nomeArquivoDownload = () => {
        const nome = this.tituloPeca || this.peca.id || 'peca';
        const nomeSanitizado = String(nome)
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[\\/:*?"<>|]/g, '-')
            .replace(/\s+/g, ' ')
            .trim();
        const extensao = this.peca.tipoArquivo === 'PDF' ? 'pdf' : 'html';

        return `${nomeSanitizado || 'peca'}.${extensao}`;
    }

    renderIconeCertidao = (peca: Peca) => {
        return peca.possuiCertidao === true && <IconButton onClick={this.abrirCertidao.bind(this, peca)} size='small'>
            <IconeCertidao />
        </IconButton>
    }

    verificaDocumento = (peca: Peca) => {
        if (this.isDespachoAdmissibilidade) {
            return <IconeDespacho />;
        }

        if (peca.tipoPeca && peca.tipoPeca.tipoMinuta) {
            return (
                <span title={peca.tipoPeca.descricao}>
                    {ICONES_MINUTA.get(peca.tipoPeca.tipoMinuta)}
                </span>
            );
        }
    }

    handleClickPeca(peca: Peca) {
        if (this.carregandoVisualizacao) {
            return;
        }

        runInAction(() => this.carregandoVisualizacao = true);

        if (this.isDespachoAdmissibilidade) {
            this.abrirDespachoAdmissibilidade()
                .finally(() => runInAction(() => this.carregandoVisualizacao = false));
            return;
        }

        if (peca.tipoArquivo === 'PDF') {
            fetch(InformacoesProcessoService.consultarConteudo(peca.idProcesso, peca.id), {
                method: 'GET',
                responseType: "blob"
            })
                .then((r) => r.data as Blob)
                .then(blob => {
                    this.props.openPeca(blob);
                    //this.showFile(blob, 'Certidao');
                })
                .finally(() => runInAction(() => this.carregandoVisualizacao = false));
        } else {
            fetch(InformacoesProcessoService.consultarConteudo(peca.idProcesso, peca.id), {
                method: 'GET'
            })
                .then((r) => atob((r.data as any).conteudoBase64))
                .then(blob => {
                    this.props.openPeca(blob);
                    //this.showFile(blob, 'Certidao');
                })
                .finally(() => runInAction(() => this.carregandoVisualizacao = false));
        }

    }

    abrirDespachoAdmissibilidade = async () => {
        if (!this.numeroProcessoDespachoAdmissibilidade) {
            MensagemStore.apresentarErro('Não foi possível identificar o número do processo para gerar o despacho de admissibilidade.');
            return;
        }

        try {
            const html = await this.buscarHtmlDespachoAdmissibilidade();

            if (!html) {
                MensagemStore.apresentarErro('O servidor não retornou conteúdo para o despacho de admissibilidade.');
                return;
            }

            this.props.openHTML?.(html);
        } catch (_e) {
            MensagemStore.apresentarErro('Não foi possível carregar o despacho de admissibilidade.');
        }
    }

    buscarHtmlDespachoAdmissibilidade = async (): Promise<string> => {
        const url = Configuracao.urlVariaveisDeModelo
            .replace('{NUMERO_PROCESSO}', encodeURIComponent(this.numeroProcessoDespachoAdmissibilidade))
            .replace('{VARIAVEL}', encodeURIComponent(VARIAVEL_DESPACHO_ADMISSIBILIDADE));

        const resposta = await fetch<any>(url, { method: 'GET' });
        return this.extrairHtmlDespachoAdmissibilidade(resposta.data);
    }

    extrairHtmlDespachoAdmissibilidade = (dados: any): string => {
        if (typeof dados === 'string') {
            return dados;
        }

        if (!dados || typeof dados !== 'object') {
            return '';
        }

        const chave = Object.keys(dados).find(chave =>
            chave.toUpperCase() === CHAVE_DESPACHO_ADMISSIBILIDADE
        );

        return chave ? dados[chave] : '';
    }

    baixarPeca = (event: React.MouseEvent) => {
        event.stopPropagation();

        if (this.carregandoDownload) {
            return;
        }

        runInAction(() => this.carregandoDownload = true);

        if (this.isDespachoAdmissibilidade) {
            this.baixarDespachoAdmissibilidadeComoPdf()
                .finally(() => runInAction(() => this.carregandoDownload = false));
            return;
        }

        if (this.peca.tipoArquivo === 'PDF') {
            fetch(InformacoesProcessoService.consultarConteudo(this.peca.idProcesso, this.peca.id), {
                method: 'GET',
                responseType: "blob"
            })
                .then((r) => r.data as Blob)
                .then(blob => {
                    this.baixarArquivo(blob, this.nomeArquivoDownload());
                })
                .finally(() => runInAction(() => this.carregandoDownload = false));
        } else {
            fetch(InformacoesProcessoService.consultarConteudo(this.peca.idProcesso, this.peca.id), {
                method: 'GET'
            })
                .then((r) => atob((r.data as any).conteudoBase64))
                .then(conteudo => {
                    const blob = new Blob([conteudo], { type: 'text/html;charset=utf-8' });
                    this.baixarArquivo(blob, this.nomeArquivoDownload());
                })
                .finally(() => runInAction(() => this.carregandoDownload = false));
        }

    }

    baixarDespachoAdmissibilidadeComoPdf = async () => {
        if (!this.numeroProcessoDespachoAdmissibilidade) {
            MensagemStore.apresentarErro('Não foi possível identificar o número do processo para baixar o despacho de admissibilidade.');
            return;
        }

        try {
            const html = await this.buscarHtmlDespachoAdmissibilidade();

            if (!html) {
                MensagemStore.apresentarErro('O servidor não retornou conteúdo para o despacho de admissibilidade.');
                return;
            }

            this.imprimirHtmlComoPdf(html);
        } catch (_e) {
            MensagemStore.apresentarErro('Não foi possível baixar o despacho de admissibilidade.');
        }
    }

    imprimirHtmlComoPdf = (html: string) => {
        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.right = '0';
        iframe.style.bottom = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = '0';
        iframe.style.visibility = 'hidden';
        document.body.appendChild(iframe);

        const iframeWindow = iframe.contentWindow;
        const iframeDocument = iframe.contentDocument || iframeWindow?.document;

        if (!iframeWindow || !iframeDocument) {
            document.body.removeChild(iframe);
            MensagemStore.apresentarErro('Não foi possível preparar o PDF para download.');
            return;
        }

        const titulo = `${this.tituloPeca} - ${this.numeroProcessoDespachoAdmissibilidade}`;
        const htmlImpressao = this.montarHtmlImpressao(html, titulo);

        const removerIframe = () => {
            setTimeout(() => {
                if (iframe.parentNode) {
                    iframe.parentNode.removeChild(iframe);
                }
            }, 500);
        };

        iframe.onload = () => {
            iframeWindow.focus();
            iframeWindow.onafterprint = removerIframe;
            iframeWindow.print();
            setTimeout(removerIframe, 30000);
        };

        iframeDocument.open();
        iframeDocument.write(htmlImpressao);
        iframeDocument.close();
    }

    montarHtmlImpressao = (html: string, titulo: string) => {
        if (/<html[\s>]/i.test(html)) {
            return html.replace(/<head([^>]*)>/i, `<head$1><title>${titulo}</title>`);
        }

        return `
            <!doctype html>
            <html>
                <head>
                    <meta charset="utf-8" />
                    <title>${titulo}</title>
                </head>
                <body>${html}</body>
            </html>
        `;
    }

    abrirHTML = () => {
        fetch(this.peca.urlDocumentoHTML, {
            method: 'GET',
            responseType: "blob"
        })
            .then((r) => r.data as Blob)
            .then(blob => {
                this.props.openHTML(blob);
                //this.showFile(blob, 'Certidao');
            });
    }

    get isOrigemEsij() {
        if (ProcessoExpandidoStore?.dadosProcesso?.origem === EnumOrigemProcesso.LEGADO ||
            this.props.dadosProcesso?.origem === EnumOrigemProcesso.LEGADO) {
            return true;
        } else {
            return false;
        }
    }

    get tituloPeca() {
        if (this.isDespachoAdmissibilidade) {
            return this.peca.titulo;
        }

        if (this.peca.peticaoNaoLida && this.isOrigemEsij) {
            return this.peca.assuntoPeticao;
        }

        return this.descricaoDocumento || this.peca.titulo || this.peca.assuntoPeticao;
    }

    get tipoDocumentoPeca() {
        return this.peca.assuntoPeticao || this.tipoDocumentoExtraido;
    }

    get deveExibirTipoDocumentoPeca() {
        if (this.isDespachoAdmissibilidade) {
            return false;
        }

        return !!this.tipoDocumentoPeca
            && this.normalizarTexto(this.tipoDocumentoPeca) !== this.normalizarTexto(this.tituloPeca);
    }

    get descricaoDocumento() {
        return this.isOrigemEsij ? this.descricaoDocumentoExtraida : this.peca.titulo;
    }

    get tipoDocumentoExtraido() {
        return this.extrairTipoEDescricao(this.peca.titulo).tipo;
    }

    get descricaoDocumentoExtraida() {
        return this.extrairTipoEDescricao(this.peca.titulo).descricao;
    }

    get complementoPeca() {
        if (this.peca.peticaoNaoLida && this.isOrigemEsij) {
            return this.peca.numPeticao ? `Petição ${this.peca.numPeticao}` : undefined;
        }

        return undefined;
    }

    get idPeca() {
        return this.peca.idUnicoDocumento;
    }

    get numSeqPeca() {
        return this.peca.numSeqPeca;
    }

    get identificadorPeca() {
        if (this.isOrigemEsij) {
            return this.numSeqPeca != null
                ? {
                    label: 'Sequencial',
                    valor: String(this.numSeqPeca),
                    tooltip: 'Copiar sequencial da peça',
                    mensagemCopiado: 'Sequencial copiado.',
                    mensagemErro: 'Não foi possível copiar o sequencial.'
                }
                : undefined;
        }

        return this.idPeca
            ? {
                label: 'ID',
                valor: this.idPeca,
                tooltip: 'Copiar ID da peça',
                mensagemCopiado: 'ID copiado.',
                mensagemErro: 'Não foi possível copiar o ID.'
            }
            : undefined;
    }

    get identificadorPeticao() {
        return this.isOrigemEsij && this.peca.numPeticao
            ? {
                label: 'Petição',
                valor: String(this.peca.numPeticao),
                tooltip: 'Copiar número da petição',
                mensagemCopiado: 'Número da petição copiado.',
                mensagemErro: 'Não foi possível copiar o número da petição.'
            }
            : undefined;
    }

    extrairTipoEDescricao(valor: string) {
        const texto = valor || '';
        const resultado = texto.match(/^(.+?)\((.+)\)$/);

        if (!resultado) {
            return { tipo: undefined, descricao: texto };
        }

        return {
            tipo: resultado[1].trim(),
            descricao: resultado[2].trim()
        };
    }

    normalizarTexto(valor: string) {
        return (valor || '').trim().toLowerCase().replace(/\s+/g, ' ');
    }

    get processo() {
        return EscaninhoStore.processosPorTipoEscaninhoFiltrado.find(proc => proc.identificadorProcesso === this.peca.idProcesso);
    }

    handleKeyDownPeca = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.handleClickPeca(this.peca);
        }
    }

    bloquearAberturaPeca = (event: React.MouseEvent) => {
        event.stopPropagation();
    }

    copiarIdentificadorPeca = async (event: React.MouseEvent | React.KeyboardEvent) => {
        event.stopPropagation();

        const identificadorPeca = this.identificadorPeca;

        if (!identificadorPeca) {
            return;
        }

        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(identificadorPeca.valor);
            } else {
                const textArea = document.createElement('textarea');
                textArea.value = identificadorPeca.valor;
                textArea.style.position = 'fixed';
                textArea.style.opacity = '0';
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
            }

            MensagemStore.apresentarMensagem(identificadorPeca.mensagemCopiado);
        } catch (_e) {
            MensagemStore.apresentarErro(identificadorPeca.mensagemErro);
        }
    }

    copiarIdentificadorPeticao = async (event: React.MouseEvent | React.KeyboardEvent) => {
        event.stopPropagation();

        const identificadorPeticao = this.identificadorPeticao;

        if (!identificadorPeticao) {
            return;
        }

        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(identificadorPeticao.valor);
            } else {
                const textArea = document.createElement('textarea');
                textArea.value = identificadorPeticao.valor;
                textArea.style.position = 'fixed';
                textArea.style.opacity = '0';
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
            }

            MensagemStore.apresentarMensagem(identificadorPeticao.mensagemCopiado);
        } catch (_e) {
            MensagemStore.apresentarErro(identificadorPeticao.mensagemErro);
        }
    }

    handleKeyDownIdentificadorPeca = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.copiarIdentificadorPeca(event);
        }
    }

    handleKeyDownIdentificadorPeticao = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.copiarIdentificadorPeticao(event);
        }
    }

    render() {
        const dataJuntada = this.peca.juntadoEm ? moment(this.peca.juntadoEm).format('DD/MM/YYYY') : '-';
        const identificadorPeca = this.identificadorPeca;
        const identificadorPeticao = this.identificadorPeticao;
        const textoMetadado = this.isDespachoAdmissibilidade
            ? 'Peça processual destacada automaticamente'
            : dataJuntada;

        return (
            <div
                className={`peca ${this.peca.ativo === false ? "peca--inativa" : ""} ${this.isPeticaoPendente ? "peca--pendente" : ""}`}
                onClick={() => { this.handleClickPeca(this.peca) }}
                onKeyDown={this.handleKeyDownPeca}
                role='button'
                tabIndex={0}
                aria-label={`Visualizar peça ${this.tituloPeca}`}
            >
                <div
                    className='peca__conteudo'
                >
                    <span className='peca__icone'>
                        {this.verificaDocumento(this.peca) || <Description fontSize='small' />}
                    </span>
                    <span className='peca__texto'>
                        <span className='peca__tituloLinha'>
                            <span className='peca__titulo'>{this.tituloPeca}</span>
                            {this.props.exibirSituacaoPeticao !== false && this.peca.descricaoPeticaoStatus != null &&
                                <span className='peca__situacao' onClick={this.bloquearAberturaPeca}>
                                    <ModalSituacaoPeca peca={this.peca} />
                                </span>
                            }
                            {this.peca.ativo === false &&
                                <Tooltip title='Peça excluída pelo magistrado'>
                                    <span className='peca__chipExcluida'>Excluída</span>
                                </Tooltip>
                            }
                            {this.isPeticaoPendente && <Chip className='peca__chip' size='small' color='warning' label='Pendente' />}
                            {this.peca.principal && <Chip className='peca__chip' size='small' color='primary' variant='outlined' label='Principal' />}
                            {this.isDespachoAdmissibilidade &&
                                <>
                                    <Chip className='peca__chip' size='small' color='success' variant='outlined' label='Gerada Automaticamente' />
                                    <Tooltip title='Esta não é uma peça do processo. É um atalho para acessar com mais facilidade o texto do despacho de admissibilidade.'>
                                        <span className='peca__infoAtalho' onClick={this.bloquearAberturaPeca}>
                                            <InfoOutlined fontSize='inherit' />
                                        </span>
                                    </Tooltip>
                                </>
                            }
                        </span>
                        <span className='peca__metadados'>
                            {this.deveExibirTipoDocumentoPeca && <span>{this.tipoDocumentoPeca}</span>}
                            <span>{textoMetadado}</span>
                            {identificadorPeca &&
                                <Tooltip title={identificadorPeca.tooltip}>
                                    <span>
                                        <span
                                            className='peca__idCopiavel'
                                            role='button'
                                            tabIndex={0}
                                            onClick={this.copiarIdentificadorPeca}
                                            onKeyDown={this.handleKeyDownIdentificadorPeca}
                                        >
                                            {identificadorPeca.label}: {identificadorPeca.valor}
                                        </span>
                                    </span>
                                </Tooltip>
                            }
                            {identificadorPeticao &&
                                <Tooltip title={identificadorPeticao.tooltip}>
                                    <span>
                                        <span
                                            className='peca__idCopiavel'
                                            role='button'
                                            tabIndex={0}
                                            onClick={this.copiarIdentificadorPeticao}
                                            onKeyDown={this.handleKeyDownIdentificadorPeticao}
                                        >
                                            {identificadorPeticao.label}: {identificadorPeticao.valor}
                                        </span>
                                    </span>
                                </Tooltip>
                            }
                        </span>
                    </span>
                    <span className='peca__acaoHtml'>
                        {this.processo?.ehLegado && this.peca.urlDocumentoHTML &&
                            <Tooltip title='Abrir em formato HTML'>
                                <span onClick={this.bloquearAberturaPeca}>
                                    <IconButton size='small' onClick={this.abrirHTML}>
                                        <OpenInNew />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        }
                    </span>
                    <span className='peca__acaoDownload' onClick={this.bloquearAberturaPeca}>
                        <Tooltip title={this.isDespachoAdmissibilidade ? 'Salvar peça como PDF' : 'Baixar peça'}>
                            <IconButton size='small' color='primary' disabled={this.carregandoDownload} onClick={this.baixarPeca} aria-label='Baixar peça'>
                                {this.carregandoDownload
                                    ? <CircularProgress size={20} thickness={5} />
                                    : <CloudDownload />
                                }
                            </IconButton>
                        </Tooltip>
                    </span>
                    <span className='peca__acao'>
                        {this.carregandoVisualizacao
                            ? <CircularProgress size={14} thickness={5} color='inherit' />
                            : 'Visualizar'
                        }
                    </span>
                </div>
            </div>
        );
    }
});
